// extracted by mini-css-extract-plugin
export default {"cardBody":"CardBody_cardBody__fk1Zc"};